module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-at-bcff2be72dbe23425afe20333086e298.svg";